import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down 600px
      const scrolled = window.scrollY > 600;
      // Hide when near bottom (footer area) to prevent overlap
      const nearBottom = window.innerHeight + window.scrollY >= document.body.offsetHeight - 400;
      setIsVisible(scrolled && !nearBottom);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-73">
      {isVisible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.3
    }} className="fixed bottom-0 left-0 right-0 z-50 bg-[#0a0a0a] border-t border-accent shadow-2xl pb-safe" data-id="element-74">
          <div className="max-w-6xl mx-auto px-4 py-4 flex items-center justify-between gap-4" data-id="element-75">
            <div className="hidden md:flex flex-col" data-id="element-76">
              <span className="text-white font-bold uppercase tracking-wide" data-id="element-77">
                A1C Shockproof (50+)
              </span>
              <span className="text-accent text-sm font-bold" data-id="element-78">
                $6.36 — Instant Access
              </span>
            </div>

            <div className="md:hidden" data-id="element-79">
              <span className="text-accent font-bold text-lg" data-id="element-80">$6.36</span>
            </div>

            <button onClick={() => document.getElementById('final-cta')?.scrollIntoView({
          behavior: 'smooth'
        })} className="flex-1 md:flex-none px-6 py-3 bg-accent hover:bg-[#d55515] text-white font-bold rounded shadow-lg glow-orange transition-all duration-300 flex items-center justify-center gap-2 uppercase tracking-wider text-sm md:text-base" data-id="element-81">
              Get The Protocol
              <ArrowRight className="w-4 h-4 md:w-5 md:h-5" data-id="element-82" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}